import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  Button,
  Typography,
  Box,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
} from "@material-ui/core";
import useStyles from "../../../themes/style.js";
import { IoChevronDownSharp } from "react-icons/io5";
import axios from "axios";
import { useNotification } from "../../../hooks/useNotification.js";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "../../../css/view-resume.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import moment from "moment";
import MUIDataTable from "mui-datatables";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useHistory } from "react-router-dom";
import { Alert, AlertTitle } from "@mui/material";

const GenerateLeaveBalance = () => {
  const classes = useStyles();
  const calendarRef = useRef(null);
  const history = useHistory();
  const mobileQuery = useMediaQuery("(max-width:600px)");
  const handleNotificationCall = useNotification();
  const [loader, setLoader] = useState(false);

  const token = localStorage.getItem("token");
  const [empPayslipData, setEmpPayslipData] = useState([]);
  const [leaveBalanceData, setLeaveBalanceData] = useState([]);
  const [downloadExcelData, setDownloadExcelData] = useState([]);

  const [payslipGenerateDate, setPayslipGenerateDate] = useState(new Date());
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [leaveBalanceUploadModal, setLeaveBalanceUploadModal] = useState(false);

  const handlePayslipMonthChange = (date) => {
    setCalendarOpen(!calendarOpen);
    setPayslipGenerateDate(date);
  };
  const handlePayslipCalendarOpen = (e) => {
    e.preventDefault();
    setCalendarOpen(!calendarOpen);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setCalendarOpen(false);
      }
    }

    if (calendarOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [calendarOpen]);


  useEffect(() => {
    fetchData();
  }, []);


  const handleGeneratePayslip = async () => {
    const monthIndex = new Date(payslipGenerateDate).getMonth();
    const fullyear = new Date(payslipGenerateDate).getFullYear();
    try {
      setLoader(true);

      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}payslip/generateBulkPayslips`,
        {
          monthIndex: monthIndex,
          year: fullyear,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      setLoader(false);
      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        setLeaveBalanceUploadModal(false);
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const fetchData = async () => {
    try {
      setLoader(true);

      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}leave/getAllExcelLeaveBalance`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      setLoader(false);
      if (response.data.status) {
        const responseData = response.data.data;

        setLeaveBalanceData(responseData);

        const downloadableData = responseData.map((item) => ({
          Name: item.user.fullName,
          Email: item.user.email,
          CL: item.casual,
          SL: item.sick,
          PL: item.personal,
          "No of Permission": item.permission,
        }));
        setDownloadExcelData(downloadableData);
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const exportToExcel = () => {
    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(downloadExcelData);

    // Create a workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Generate the Excel file
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Save the file
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(
      blob,
      `employee_payslip_${moment(payslipGenerateDate).format(
        "DD-MM-YYYY",
      )}.xlsx`,
    );
    history.push("/app/employee/leave-balance/upload-leave-balance?tab=1");
  };

  const HeaderElements = () => (
    <Box display="flex" alignItems="baseline" gridGap={4}>
      <Typography>Total : {empPayslipData.length}</Typography>
    </Box>
  );

  const renderMonthContent = (month, shortMonth, longMonth, day) => {
    const fullYear = new Date(day).getFullYear();
    const tooltipText = `Month: ${longMonth} ${fullYear}`;

    return <span title={tooltipText}>{shortMonth}</span>;
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box
            display="flex"
            justifyContent="end"
            alignItems="center"
            gridColumnGap={8}
            width="100%"
            ref={calendarRef}
          >
            <Button
              variant="contained"
              color="primary"
              size="small"
              component="label"
              onClick={() => setLeaveBalanceUploadModal(true)}
            >
              Generate
            </Button>

            <Button
              variant="outlined"
              size="small"
              color="primary"
              className="example-custom-input"
              endIcon={<IoChevronDownSharp />}
              onClick={handlePayslipCalendarOpen}
            >
              {moment(payslipGenerateDate).format("MMM-yyyy")}
            </Button>
            {calendarOpen && (
              <Box
                position="relative"
                zIndex={111}
                className="payslip-month-picker-container"
              >
                <DatePicker
                  selected={payslipGenerateDate}
                  onChange={handlePayslipMonthChange}
                  renderMonthContent={renderMonthContent}
                  showMonthYearPicker
                  dateFormat="MM/yyyy"
                  wrapperClassName="payslip-month-calender"
                  popperClassName="payslip-month-calender-popper"
                  inline
                />
              </Box>
            )}
            <Button
              variant="contained"
              color="primary"
              size="small"
              component="label"
              onClick={exportToExcel}
            >
              Export Data
            </Button>
          </Box>
        </Grid>
      </Grid>

      <Grid container direction="row" justifyContent="center" spacing={2}>
        <Grid item xs={12}>
          <Box className={classes.generatePayslipTable}>
            <MUIDataTable
              title=""
              options={{
                textLabels: {
                  body: {
                    noMatch: "Oops! Matching record could not be found",
                  },
                },
                pagination: false,
                sort: false,
                selectableRows: "none",
                search: false,
                filter: false,
                download: false,
                print: false,
                fixedSelectColumn: true,
                customToolbar: () => (
                  <>
                    <HeaderElements />
                  </>
                ),
                responsive: mobileQuery === true ? "vertical" : "standard",
              }}
              columns={[
                {
                  name: "S.No",
                },
                {
                  name: "Name",
                },
                {
                  name: "Email",
                },
                {
                  name: "CL",
                },
                {
                  name: "SL",
                },
                {
                  name: "PL",
                },
                {
                  name: "No of Permission",
                },
                {
                  name: "Last Update",
                },
              ]}
              data={leaveBalanceData.map((item, index) => {
                return [
                  <>{index + 1}</>,
                  <Box
                    sx={{
                      color: "inherit",
                      position: "relative",
                    }}
                  >
                    {item.user.fullName}
                  </Box>,
                  item.user.email,
                  item.casual,
                  item.sick,
                  item.personal,
                  item.permission,
                  moment(item.updatedAt).format('DD-MM-YYYY'),
                ];
              })}
            />
          </Box>
        </Grid>
      </Grid>

      <Dialog
        open={leaveBalanceUploadModal}
        fullWidth
        maxWidth="xs"
        onClose={() => {
          setLeaveBalanceUploadModal(false);
        }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle>{`Generate Leave Balance ${moment(payslipGenerateDate).format(
          "MMM YYYY",
        )}`}</DialogTitle>
        <DialogContent>
          <Box>
            <Typography variant="body2">
              Processed payslips only send through this action.
            </Typography>
            <Alert icon={false} severity="warning">
              <AlertTitle>Note:</AlertTitle>
              <Box component="ul" style={{ listStyle: "disc" }}>
                <Typography component="li">
                  Once the leave balance is sent, you will not be able to make any
                  further changes to the leave balance details.
                </Typography>
                <Typography component="li">
                  Please review the leave balance carefully before generating.
                </Typography>
              </Box>
            </Alert>
          </Box>
        </DialogContent>
        <DialogActions style={{ padding: "12px 24px" }}>
          <Button
            onClick={() => {
              setLeaveBalanceUploadModal(false);
            }}
            variant="contained"
            color="secondary"
            size="small"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleGeneratePayslip}
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default GenerateLeaveBalance;
